import React from "react";
import './AboutUsPage.css'; // Import CSS for styling

// Import images
import aboutUsImage from '../assets/images/about-us.jpg.jpg'; // Main Image
import img1 from '../assets/images/photo1.jpg.jpg'; // Additional Images
import img2 from '../assets/images/photo2.jpg.jpg';
import img3 from '../assets/images/certificate-us1.jpg.jpg';
import img4 from '../assets/images/certificate-us2.jpg.jpg';
import img5 from '../assets/images/certificate-us3.jpg.jpg';
import img6 from '../assets/images/certificate-us4.jpg.jpg';
import img7 from '../assets/images/certificate-us5.jpg.jpg';
import img8 from '../assets/images/certificate-us6.jpg.jpg';
// Import videos
import aboutUsVideo from '../assets/videos/about-us-video.mp4'; // Video 1
import anotherVideo from '../assets/videos/another-video.mp4.mp4'; // Video 2

const AboutUsPage = () => (
  <div className="about-us-page">
    <h1>About Us</h1>
    <div className="about-us-content">

      {/* Main Image Section */}
      <img src={aboutUsImage} alt="About Us" className="about-us-image" />

      {/* Video Section 1 */}
      <video className="about-us-video" controls>
        <source src={aboutUsVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Video Section 2 */}
      <video className="about-us-video" controls>
        <source src={anotherVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Additional Photos Section */}
      <div className="image-gallery">
        <img src={img1} alt="Car 1" className="gallery-image" />
        <img src={img2} alt="Car 2" className="gallery-image" />
        <img src={img3} alt="Car 3" className="gallery-image" />
        <img src={img4} alt="Car 4" className="gallery-image" />
        <img src={img5} alt="Car 5" className="gallery-image" />
        <img src={img6} alt="Car 6" className="gallery-image" />
        <img src={img7} alt="Car 7" className="gallery-image" />
        <img src={img8} alt="Car 8" className="gallery-image" />
      </div>

      {/* Text Section */}
      <div className="about-us-text">
        <p>
          Welcome to <strong>STAR PRE-OWNED CARZ</strong>. Founded by <strong>Syed Shafiq</strong> and <strong>Sameer Baig</strong>, 
          we specialize in certified pre-owned cars. Our goal is to provide high-quality vehicles with 
          transparent pricing and excellent customer service.
        </p>
        <p>
          At STAR PRE-OWNED CARZ, we are committed to helping you find the perfect car to match your needs.
        </p>
      </div>
    </div>
  </div>
);

export default AboutUsPage;
